import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_ERROR,
  INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_FAILURE,
  INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_REQUEST,
  INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_SUCCESS,
} from '../../../../actions/actionTypes';

const defaultState = {
  isLoading: false,
  response: {
    status: null,
  },
  error: {},
};

const searchDetectionLinkAccount = (state = defaultState, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        response: {
          status: null,
        },
      };
    }

    case INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        response: {
          status: action.payload.response.status,
        },
      };
    }

    case INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_ERROR:
    case INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        response: {
          status: action.payload.response.status,
        },
        error: action.payload.error,
      };
    }

    case INCIDENT_DETAILS_CLEAR:
      return defaultState;

    default:
      return state;
  }
};

export default searchDetectionLinkAccount;
